
export const emailPattern = /^(?=.{1,256})(?=.{1,64}@)[A-Za-z0-9_-]+(?:\.[A-Za-z0-9_-]+)*@[A-Za-z0-9_-]+(?:\.[A-Za-z0-9_-]+)*(?:\.[A-Za-z]{2,})$/
export const phonePattern = /^\d{8,13}$/